const CART_EXPIRATION_TIME_KEY = 'ofra_cart_expiration_time';
const EXPIRATION_HOURS = 5; 
let timerUpdateInterval = null;

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;


function initCartTimer() {
 
  if (!localStorage.getItem(CART_EXPIRATION_TIME_KEY)) {

    const currentTime = new Date().getTime();
    const expirationTime = currentTime + (EXPIRATION_HOURS * HOUR);
    
    localStorage.setItem(CART_EXPIRATION_TIME_KEY, expirationTime.toString());
    
  }
  
  if (!timerUpdateInterval) {
    updateTimerDisplay();
    timerUpdateInterval = setInterval(updateTimerDisplay, 1000);
  }
}

/**
 * clear cart and timer
 */
function clearCartAndTimer() {
  // stop the interval
  if (timerUpdateInterval) {
    clearInterval(timerUpdateInterval);
    timerUpdateInterval = null;
  }
  
  // delete the timer
  localStorage.removeItem(CART_EXPIRATION_TIME_KEY);
  
  // clear cart
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {

    window.location.reload();
  })
  .catch(error => console.error('Error al limpiar el carrito:', error));
}

/**
 * Update the timer display
 */
function updateTimerDisplay() {
  const timerContainer = document.getElementById('cart-expiration-timer');
  if (!timerContainer) return;
  
  const expirationTime = localStorage.getItem(CART_EXPIRATION_TIME_KEY);
  
  if (expirationTime === null) {
    timerContainer.style.display = 'none';
    return;
  }
  
  const expirationTimeInt = parseInt(expirationTime, 10);
  const currentTime = new Date().getTime();
  const timeRemaining = expirationTimeInt - currentTime;
  
  if (timeRemaining <= 0) {
    timerContainer.style.display = 'none';
    clearCartAndTimer();
    return;
  }
  
  // shop time expire
  timerContainer.style.display = 'block';
  
// update timer
  document.getElementById('timer-hours').textContent = 
    Math.floor((timeRemaining / HOUR) % 24).toString().padStart(2, '0');
  
  document.getElementById('timer-minutes').textContent = 
    Math.floor((timeRemaining / MINUTE) % 60).toString().padStart(2, '0');
  
  document.getElementById('timer-seconds').textContent = 
    Math.floor((timeRemaining / SECOND) % 60).toString().padStart(2, '0');
}

/**
 * Initialize the timer 
 */
document.addEventListener('DOMContentLoaded', function() {
  // 1. If the cart already has items, start the timer

  initCartTimer();
  
  
  // 2. Listen for submit of add to cart forms
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form.action && form.action.includes('/cart/add')) {
      initCartTimer();
    }
  });
  
  // 3.   Listen for Shopify Ajax Cart events
  document.addEventListener('cart:refresh', function() {
    initCartTimer();
  });
  
  document.addEventListener('cart:updated', function() {
    initCartTimer();
  });
  
  // 4. Listen for cart open
  document.querySelectorAll('[data-cart-toggle], [data-drawer-toggle="cart-drawer"], .cart-toggle').forEach(function(button) {
    button.addEventListener('click', function() {
      setTimeout(function() {
        if (document.querySelectorAll('.cart-item').length > 0) {
          initCartTimer();
        }
      }, 500);
    });
  });
});

if (document.readyState !== 'loading') {
  if (document.querySelectorAll('.cart-item').length > 0) {
    initCartTimer();
  }
}

